export default __webpack_public_path__ + "static/media/image-community-2.4e46c5a1.png";